import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import PageHeader from "../components/PageHeader";
import EmptyState from "../components/EmptyState";
import ComposeEmailModal from "../components/ComposeEmailModal";
import { ContactCard } from "./job/ContactsTab";

const FILTERS = [
  { id: "all", label: "All" },
  { id: "todo", label: "Not contacted" },
  { id: "emailed", label: "Emailed" },
];

function Contacts() {
  const { jobs, updateJob, toast } = useApp();

  const deleteContact = async (job, contact) => {
    const saved = await updateJob(job.id, { contacts: job.contacts.filter((c) => c.id !== contact.id) });
    if (saved) toast(`Removed ${contact.name}`);
  };

  const saveContactEmail = async (job, contact, email) => {
    const saved = await updateJob(job.id, {
      contacts: job.contacts.map((c) => (c.id === contact.id ? { ...c, email } : c)),
    });
    if (saved) toast(`Email saved for ${contact.name}`);
    return Boolean(saved);
  };
  const [filter, setFilter] = useState("all");
  const [query, setQuery] = useState("");
  const [compose, setCompose] = useState(null);

  const all = jobs.flatMap((job) => (job.contacts || []).map((contact) => ({ contact, job })));
  const q = query.trim().toLowerCase();
  const shown = all.filter(({ contact, job }) => {
    if (filter === "todo" && contact.emailed) return false;
    if (filter === "emailed" && !contact.emailed) return false;
    return !q || `${contact.name} ${contact.email} ${job.company}`.toLowerCase().includes(q);
  });

  const composeJob = compose && jobs.find((j) => j.id === compose.jobId);
  const composeContact = composeJob && composeJob.contacts.find((c) => c.id === compose.contactId);

  return (
    <>
      <PageHeader title="Contacts" subtitle="Recruiters, hiring managers and senior peers from all your jobs, in one place." />

      {all.length === 0 ? (
        <div className="card">
          <EmptyState
            icon="bi-people"
            title="No contacts yet"
            text="Open a job, find people on LinkedIn from its Contacts tab, and add them here."
            action={
              <Link to="/tracker" className="btn btn-primary btn-sm">
                Go to tracker
              </Link>
            }
          />
        </div>
      ) : (
        <>
          <div className="d-flex flex-column flex-md-row gap-2 mb-3">
            <div className="input-group tracker-search">
              <span className="input-group-text bg-white">
                <i className="bi bi-search" />
              </span>
              <input
                className="form-control"
                placeholder="Search by name, email or company"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                aria-label="Search contacts"
              />
            </div>
            <div className="chip-scroll ms-md-auto">
              {FILTERS.map((f) => (
                <button key={f.id} className={`chip ${filter === f.id ? "active" : ""}`} onClick={() => setFilter(f.id)}>
                  {f.label}
                </button>
              ))}
            </div>
          </div>

          {shown.length === 0 ? (
            <div className="card">
              <EmptyState icon="bi-funnel" title="No contacts match" text="Try a different search or filter." />
            </div>
          ) : (
            <div className="d-flex flex-column gap-2">
              {shown.map(({ contact, job }) => (
                <div key={`${job.id}-${contact.id}`} className="card">
                  <div className="card-body p-0">
                    <ContactCard
                      contact={contact}
                      subtitle={
                        <>
                          {contact.title} at {job.company} ·{" "}
                          <Link to={`/jobs/${job.id}?tab=contacts`}>{job.title}</Link>
                        </>
                      }
                      onEmail={() => setCompose({ jobId: job.id, contactId: contact.id })}
                      onDelete={(c) => deleteContact(job, c)}
                      onSaveEmail={(c, email) => saveContactEmail(job, c, email)}
                    />
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {composeContact && (
        <ComposeEmailModal key={composeContact.id} job={composeJob} contact={composeContact} onClose={() => setCompose(null)} />
      )}
    </>
  );
}

export default Contacts;
